import { IconConfig, UIConfig } from '../models/appState';
import * as LucideIcons from 'lucide-react';
import OutlinedMoldIcon from '../components/icons/OutlinedMoldIcon';

// Map of custom icons
const customIcons = {
    OutlinedMoldIcon,
};

export const getIconComponent = (uiConfig: UIConfig): React.ComponentType | null => {
    return getDynamicIcon(uiConfig.icon);
};

export const getDynamicIcon = (iconConfig: IconConfig): React.ComponentType | null => {
    const { name, source } = iconConfig;
    if (source === 'lucide') {
        const IconComponent = (LucideIcons as any)[name];
        if (!IconComponent) {
            console.warn(`Lucide icon "${name}" not found`);
            return null;
        }
        return IconComponent;
    } else if (source === 'custom') {
        const IconComponent = (customIcons as any)[name];
        if (!IconComponent) {
            console.warn(`Custom icon "${name}" not found`);
            return null;
        }
        return IconComponent;
    } else {
        console.warn(`Unknown icon source "${source}"`);
        return null;
    }
}